import { BuildingTypeResponse } from "@/web-client/api";
import { useMemo } from "react";
import useBuildingTypes from "./useBuildingTypes";

const useExistBuildingType = (): BuildingTypeResponse[] => {
  const buildingTypes = useBuildingTypes();
  const existBuildingTypes = useMemo(
    () =>
      buildingTypes
        .filter((b) => b.posts_count > 0)
        .map((b) => {
          if (b.children) {
            b.children = b.children.filter((b) => b.posts_count > 0);
          }

          return b;
        }),
    [buildingTypes],
  );

  return existBuildingTypes;
};

export default useExistBuildingType;
